import './rating';
import 'slick-carousel';
import './library';
import './nav';
import './navOverlay';
import './searchAndOverlayModals';
import './teaser-slider';
import './form';
import { changeHeaderStyleOnOpenModal } from './searchAndOverlayModals';
import { changeLogo, toggleTopBar } from './utils';

import './video-player';


jQuery($ => {
  const $w = $(window);
  const $d = $(document);
  const $header = $('header');
  const $topTeaser = $('.topTeaser');

  // check authorization
  require('./auth')

  function stickyAnchors() {
    // if we don't have anchors we don't do anything
    const hasAnchor = document.querySelector('.anchors')
    const hasScrolledContainer = document.querySelector('#scrolled-container')

    if (!hasAnchor || !hasScrolledContainer) return;

    const hasAnchorLengt = hasAnchor.children?.length

    if (!hasAnchorLengt) return;

    if ($topTeaser.height() <= $d.scrollTop()) {
      $header.addClass('sticky-anchors')
      $header.css('padding-bottom', $(hasScrolledContainer).height());
    } else {
      $header.removeClass('sticky-anchors')
      $header.css('padding-bottom', '');
    }
  }

  // update view based on scroll events
  $w.on('scroll touchmove resize', () => {
    if ($('body').hasClass('modal-open')) {
      changeHeaderStyleOnOpenModal()
    } else {
      changeLogo();
      stickyAnchors();
      toggleTopBar();
    }
  }).trigger('scroll');

  require('./anchors');

  require('./video-slider');

  require('./overlay-modal');

  /* Toggle active class for element of list */
  function toggleActiveClass(elem) {
    $(elem).on('click', function () {
      $(elem).each(
        function () {
          $(this).removeClass('active');
        }
      );

      $(this).addClass('active');
    })
  }

  /* Overlay menu */
  toggleActiveClass('.overlay-menu__link')

  /* Dropdown */
  const slideItem = (item, close = false) => {
    item.next().find('.dropdown__item')[close ? 'slideUp' : 'slideToggle']()
    item[close ? 'removeClass' : 'toggleClass']('open-list');
    if(!close) {
      slideItem($('.dropdown__title.open-list').not(item), true)
    }
  };
  $('.dropdown__title').on('click', function() {
    slideItem($(this))
  })

  toggleActiveClass('.dropdown__link')

  /* Accordion */
  $('.accordion__header').on('click', function () {
    let accordion = $(this).parent('.accordion');
    accordion.find('.accordion__content').slideToggle(300)
    accordion.find('.accordion__header').toggleClass('open-accordion')
  })

    if (document.querySelector('.slider-module')) {
        require('./slider-module');
    }

    if (document.querySelector('.gallery-slider')) {
        require('./gallery-slider');
    }
    if (document.querySelector('.quote-slider')) {
        require('./quote-slider');
    }
    if (document.querySelector('.article-list-slider')) {
        require('./article-list-slider');
    }

    if (document.querySelector('.bottom-slider')) {
        require('./bottom-slider');
    }

    if (document.querySelector('.related-content-slider')) {
        require('./related-content-slider')
    }
    require('./newsletter-modal')
    require('./text-image-button');
    require('./favourite');

    $('#navbarScroll .navbar-nav li a').on('click', function () {
    $('#navbarScroll .navbar-nav li a').each(function () {
      $(this).removeClass('active');
    });
    $(this).addClass('active');

    if ($('#closeSearchModal').is(':visible')) {
      $('#closeSearchModal').addClass('active');
    }
  });

  $('#loginModal .close').on('click', () => {
    $('#navbarDropdownUser').removeClass('active');
  });

  if ($('body').data('pagetype') === 'football-language') {
    require('./football-language');
    require('./football-language-search');
  }

    if ($('body').data('pagetype') === 'events_and_webinars') {
        require('./events_and_webinars');
    }


    if (document.querySelector('.events-slider-container')) {
        require('./events-slider');
    }
    if (document.querySelector('.btd-module-kts')) {
        require('./key-thought-slider');
    }

    /*
    $('#main-menu .nav-item .nav-link.first-level_menu').on('click', function () {
        const anchor = $(this);
        const parentItem = anchor.parent('li.nav-item');
        const submenuItems = $('.submenu', parentItem);
        const submenuBgElement = $('.submenu-bg');
        if (parentItem.hasClass('has-submenu')) {
            const submenuBg = submenuItems.data('bg');
            submenuBgElement.attr('data-background', submenuBg);
            if(anchor.hasClass('open') && submenuItems.hasClass('show') ) {
                anchor.removeClass('open');
                submenuBgElement.removeClass('show-submenu');
                submenuItems.removeClass('show');
                submenuBgElement.height(0);
            } else {
                $('.nav-link').removeClass('open');
                $('.submenu').removeClass('show');
                anchor.addClass('open');
                submenuItems.addClass('show');
                submenuBgElement.addClass('show-submenu');
                const heightOfSubmenu = submenuItems.height();
                submenuBgElement.height(heightOfSubmenu +20);
                submenuItems.css({'bottom': `-${heightOfSubmenu + 30}px`});
            }
            return false;
        }
    });
    */

  $('.submenu-link').each(function() {
      const submenuLink = $(this);
      const href = submenuLink.attr('href');
      if(href === window.location.pathname) {
          submenuLink.addClass('active');
      }
  });

  $('.footer-onetrust').on('click', function() {
    $('.onetrust-pc-dark-filter').removeAttr('style');
    $('.onetrust-pc-dark-filter').removeClass('ot-hide');
    $('.otPcTab').removeAttr('style');
    $('.otPcTab').removeClass('ot-hide');

  });
});
